import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n';
import { api } from '../lib/api';

export default function PrivacyPage() {
    const { t, locale } = useI18n();
    const [text, setText] = useState('Carregant la política de privacitat...');

    useEffect(() => {
        api.get('/legal', { params: { locale } })
            .then((response) => setText(response.data.privacy_text))
            .catch(() => setText('No s’ha pogut carregar la política de privacitat.'));
    }, [locale]);

    return (
        <div className="mx-auto max-w-4xl p-6">
            <h1 className="text-2xl font-bold">{t('legal.privacy_title') || 'Política de Privacitat'}</h1>
            <div className="mt-6 whitespace-pre-wrap text-sm leading-7 text-[color:var(--alb-text-muted)]">{text}</div>
        </div>
    );
}
